<template>
  <div class="container-fluid fixedElement">
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row" v-bind:class="flightHeaderClass">
              <div id="title" class="col">
                <i class="icon-flight filter-icon"></i>
                <span>{{ $t("Flight") }}</span>
              </div>
              <!-- <div id="change" class="col">
                <span>تغییر</span>
              </div> -->
            </div>
            <br />
            <div class="flight container">
              <div v-if="
                selectedFlightItems.departureFlight !== null && selectedFlightItems.returnFlight !== null &&
                sleketonItems.isDeparture === false
              " id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-reply-1"></i>
                  <div class="mleft-5 segment">
                    <span>{{
                        selectedFlightItems.departureFlight.originIATA
                    }}</span>

                    <span>{{
                        selectedFlightItems.departureFlight.departureTime
                    }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration">
                      {{
                          selectedFlightItems.departureFlight.duration.substring(
                            0,
                            5
                          )
                      }}
                    </div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{
                          selectedFlightItems.departureFlight
                            .departureDateTimeShamsiText
                      }}
                    </div>
                  </div>

                  <div class="mleft-5 segment">
                    <span>{{
                        selectedFlightItems.departureFlight.destinationIATA
                    }}</span>
                    <span>{{
                        selectedFlightItems.departureFlight.arrivalTime
                    }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1"></i>
                    <img id="airline-logo" width="28" height="28" src="../../../public/img/airlines/zv.png" />
                  </div>
                  <a @click="onChange(1)" class="change-hf">
                    <span>{{ $t("Change") }}</span>
                  </a>
                </div>
              </div>
              <SklFlight v-else />
              <hr />
              <div v-if="
                selectedFlightItems.departureFlight !== null && selectedFlightItems.returnFlight !== null &&
                sleketonItems.isReturn === false
              " id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-forward-1"></i>
                  <div class="mleft-5 segment">
                    <span>{{
                        selectedFlightItems.returnFlight.originIATA
                    }}</span>
                    <span>{{
                        selectedFlightItems.returnFlight.departureTime
                    }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration">
                      {{
                          selectedFlightItems.returnFlight.duration.substring(
                            0,
                            5
                          )
                      }}
                    </div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{
                          selectedFlightItems.returnFlight
                            .departureDateTimeShamsiText
                      }}
                    </div>
                  </div>
                  <div class="mleft-5 segment">
                    <span>{{
                        selectedFlightItems.returnFlight.destinationIATA
                    }}</span>
                    <span>{{
                        selectedFlightItems.returnFlight.arrivalTime
                    }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1 filter-icon"></i>
                    <img id="airline-logo" width="28" height="28" src="../../../public/img/airlines/zv.png" />
                  </div>
                  <a @click="onChange(2)" class="change-hf">
                    <span>{{ $t("Change") }}</span>
                  </a>
                </div>
              </div>

              <SklFlight v-else />
            </div>
          </div>
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row" v-bind:class="hotelHeaderClass">
              <div id="title" class="col">
                <i class="icon-warehouse filter-icon"></i>
                <span>{{ $t("Hotel") }}</span>
              </div>
              <a v-if="selectedFlightItems.departureFlight !== null && selectedFlightItems.returnFlight !== null"
                id="change" class="change-hf">
                <span @click="onChange(4)">{{ $t("Change") }}</span>
              </a>
            </div>
            <br />
            <div class="hotel container">
              <div style="display: flex;" v-if="
                selectedRoomItems.length > 0 && sleketonItems.isRoom === false
              ">
                <div style="padding-right: 0px" class="col-md-5">
                  <img v-if="hotelImage.length > 0" id="hotel-image" width="140" height="120" :src="hotelImage[0].url" />
                  <img v-else id="hotel-image" width="140" height="120" />
                  <HotelStars style="text-align: center" />
                </div>
                <div id="hotel-detail" class="col-md-7 container">
                  <span id="hotel-title" class="row">{{
                      selectedRoom[0].hotelName
                  }}</span>
                  <span style="font-size: 14px;display: flex;" v-for="(room, index) in filteredRooms" :key="index"><i
                      class="icon-ok-3"></i>
                    <div> {{ room.name }} ×
                      {{ room.count }}</div>
                  </span>
                  <span style="font-size: 14px;display: flex;"><i class="icon-ok-3"></i>
                    <div> {{ $t("SearchResults.Refundable") }}</div>
                  </span>
                  <span style="font-size: 14px;display: flex;"><i class="icon-ok-3"></i>
                    <div>{{ $t("SearchResults.InhabitancyWithBreakfast") }}</div>
                  </span>
                </div>
              </div>
              <SKLRoom v-else />
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
        <div v-if="
          selectedRoomItems.length > 0 && selectedFlightItems.departureFlight !== null && selectedFlightItems.returnFlight !== null && sleketonItems.isTotalPrice === false
        " class="total-pay">
          <div class="row">
            <span id="title"> {{ $t("Flight") }} + {{ $t("Hotel") }}</span>
          </div>
          <div v-if="showPrice" class="row">
            <span
              v-if="selectedFlightItems.departureFlight !== null && selectedFlightItems.returnFlight !== null"><label
                id="price">{{ flightTotalPrice | numFormat | rial }} </label> {{ $t("SearchResults.ForFlight") }}</span>
            <span v-else><label id="price">--- </label> {{ $t("SearchResults.ForFlight") }}</span>

          </div>
          <div v-if="showPrice" class="row">
            <span v-if="selectedRoomItems != null">{{ $t("SearchResults.ForFlight") }} <label id="price">{{ roomTotalPrice | numFormat | rial
            }}</label></span>
            <span v-else>{{ $t("SearchResults.ForEachNightStay") }}  <label id="price"> </label></span>

          </div>
          <div v-if="showPrice" class="liner"></div>
          <div style="    text-align: center;" class="row">
            <span v-if="selectedRoomItems != null && selectedFlightItems != null"><span style="font-size: 16px;">
                {{ $t("SearchResults.TotalTripCost") }} :</span> <label style="font-size: 14px;font-weight:bold;color: #08446a;">{{ packageTotalPrice |
                    numFormat | rial
                }}</label></span>
            <span v-else>{{ $t("SearchResults.TotalTripCost") }}  : <label style="font-weight:bold;color: #08446a;"></label></span>

          </div>
          <div class="row">
            <button v-if="isDisableButton" disabled href="#" class="btn btn-block btn-primary" data-toggle="modal"
              data-target="#myReview">{{ $t("SearchResults.CompleteReservation") }}</button>
            <button v-else @click="onSelectPackage" href="#" class="btn btn-block btn-primary" data-toggle="modal"
              data-target="#myReview">{{ $t("SearchResults.CompleteReservation") }}</button>
          </div>
        </div>
        <SKLTotalPrice v-else class="total-pay" />
      </div>
    </div>

    <div class="subtitle row">
      <div class="col">
        {{ $t("SearchResults.SaveUp15Percent") }}!
      </div>
    </div>
  </div>
</template>
<script>
import HotelStars from "../tour/HotelStars";
import SklFlight from "@/components/shared/Skeletons/SKLSelectedFlight";
import SklFlightTwoway from "@/components/shared/Skeletons/SKLSelectedTwowayFlight";
import SKLRoom from "@/components/shared/Skeletons/SKLSelectedRoom";
import SKLTotalPrice from "@/components/shared/Skeletons/SKLTotalPrice";
import jalaaliMoment from "moment-jalaali";


import dateUtil from "../../utils/date";
import moment from "moment";
export default {
  name: "SelectedPackage",

  components: { SklFlight, HotelStars, SklFlightTwoway, SKLRoom, SKLTotalPrice },
  props: {
    hotelDetails: { type: Object, default: () => ({}), },
    showPrice: Boolean,
    selectedFlight: { type: Object, default: () => ({ departureFlight: null, returnFlight: null }), },
    selectedRoom: { type: Array, default: () => ([]), },
    selectedType: { type: Number, default: 1 },
    sleketonModel: {
      type: Object,
      default: () => ({
        isDeparture: false,
        isReturn: false,
        isToway: false,
        isRoom: false,
        isTotalPrice: false
      }),
    },
    isDisableButton: Boolean
  },
  data: () => ({

    isDisableChangeRoom: true,
    isSelectedDeparture: false,
    params: {},
    totalNight: 0,
    hotelImage: [],
  }),
  created() {
    this.params = this.$route.query;
    this.calculateTotalNight();

  },
  watch: {
    hotelDetails: function (val) {
      if (Object.keys(val).length) {
        var hotelImageUrl = val.imageURL;
        val.hotelImages.forEach(img => {
          this.hotelImage.push({
            url: hotelImageUrl + img.hotelImageID,
            caption: img.caption
          });


        });
      }

    }
  },
  computed: {
    filteredRooms() {
      return this.roomCount(this.selectedRoom);
    },
    flightHeaderClass: function () {
      return {
        "head-border": this.selectedType === 1 || this.selectedType === 2,
      };
    },
    hotelHeaderClass: function () {
      return {
        "head-border": this.selectedType === 4,
      };
    },
    selectedTypeValue() {
      return (this.selectedType = this.selectedType);
    },
    sleketonItems() {
      return (this.sleketonModel = this.sleketonModel);
    },
    selectedFlightItems() {
      console.log('this.selectedFlight', this.selectedFlight);
      return (this.selectedFlight = this.selectedFlight);


    },
    selectedRoomItems() {
      this.isDisableChangeRoom = false;
      return (this.selectedRoom = this.selectedRoom);


    },
    flightTotalPrice() {
      return this.calcFlightTotalPrice(this.selectedFlight);
    },
    roomTotalPrice() {
      return this.calcRoomTotalPrice(this.selectedRoom);
    },
    packageTotalPrice() {

      var roomPrice = this.calcRoomTotalPrice(this.selectedRoom);
      var totalRoom = roomPrice * this.totalNight;

      return totalRoom + this.flightTotalPrice;
    }
  },
  methods: {
    onSelectPackage() {
      var selectedPackage = {
        flight: this.selectedFlight,
        hotel: this.selectedRoom,
        hotelDetail: this.hotelDetails,
        showPrice: this.showPrice
      };

      this.$emit('onSelectPackage', selectedPackage);

    },
    calculateTotalNight() {

      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      this.totalNight = 0;
      if (
        fromDate != "" &&
        fromDate != null &&
        toDate != "" &&
        toDate != null
      ) {
        let fDate = this.params.fromDate;
        let tDate = this.params.toDate;

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());

        // var diff = moment(tDate).diff(moment(fDate), "days");

        // var diff = moment(this.params.toDate).diff(moment(this.params.fromDate), "days");

        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },
    roomCount(array) {
      let counts = array.reduce(
        (out, { name }) => ({ ...out, [name]: out[name] + 1 || 1 }),
        {}
      );
      return Object.keys(counts).map((key) => ({
        name: key,
        count: counts[key],
      }));
    },
    onChange(stpe) {
      this.$emit("onChange", stpe);
    },
    calcFlightTotalPrice(flight) {
      var departurePrice = 0;
      var returnPrice = 0;
      var totalFlightPrice = 0
      var departureAdultPrice = flight.departureFlight.adultQty * flight.departureFlight.totalAdultFare;
      var departureInfantPrice = flight.departureFlight.infantQty * flight.departureFlight.totalInfantFare;
      var departureChildPrice = flight.departureFlight.childQty * flight.departureFlight.totalChildFare;
      departurePrice = departureAdultPrice + departureInfantPrice + departureChildPrice;
      var returnAdultPrice = flight.returnFlight.adultQty * flight.returnFlight.totalAdultFare;
      var returnInfantPrice = flight.returnFlight.infantQty * flight.returnFlight.totalInfantFare;
      var returnChildPrice = flight.returnFlight.childQty * flight.returnFlight.totalChildFare;
      returnPrice = returnAdultPrice + returnInfantPrice + returnChildPrice;
      totalFlightPrice = departurePrice + returnPrice;
      return totalFlightPrice;

    },

    calcRoomTotalPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.liner {
  border: 1px solid #eeeeee;
  margin-bottom: 8px;
  margin-top: 5px;
}

.change-hf {
    position: absolute;
    border-radius: 20px;
    background-color: #00c3e1;
    padding: 6px 20px;
    display: inline-table;
    color: #fff !important;
    font-weight: 100;
    left: 16px;
}

.change-hf:hover {
  position: absolute;
  border-radius: 20px;
  padding: 6px 20px;
  display: inline-table;
  color: #fdfeff !important;
  background: #02b1cc;
  font-weight: 100;
  left: 16px;
  cursor: pointer;
}

.flight-segment {
  text-align: center;
  color: #08446a;
  font-size: 12px;
}

#airline-logo {
  margin-top: -6px !important;
}

.title span #price {
  font-weight: bold;
}

.total-pay {
  padding: 20px 40px 14px 40px;
}

.total-pay a {
  margin-top: 14px;
}

.total-pay span {
  margin: auto;
}

.total-pay #title {
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

#hotel-detail {
  margin-right: 10px;
  line-height: 24px;
  font-size: 13px;
  padding: 0px 2px 0px 0px;
}

#hotel-title {
  margin-right: -7px;
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 11px;
  // margin-top: 14px;
}

.hotel #hotel-image {
  border-radius: 8px;
  margin-left: 5px;
}

.stop-diagram {
  height: 1px;
  background: #c7c1c1;
  width: 100px;
  margin-top: auto;
  margin-bottom: auto;

  margin-left: 8px;
  margin-right: 8px;
}

.mleft-5 {
  margin-left: 5px;
}

.head {
  margin: 0px -3px 0px -8px;
  padding-top: 6px;
  border-radius: 5px;
}

.head-border {
  border-top: 2px #fcbe2f solid;
}

.head #title {
  font-size: 15px;
  color: #5c666b;
}

.head #change {
  text-align: left;
  color: #0a6c9f;
  cursor: pointer;
  font-size: 15px;
  margin-left: 5px;
}

@media only screen and (max-width: 750px) {
  .fixedElement {
    position: inherit !important;
  }

  .b-left {
    margin-top: 20px !important;
  }

}

.fixedElement {
  background-color: rgb(255, 255, 255);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  margin-bottom: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
}

.flight {
  padding: 0px 0px 0px 0px;
}

.flight #departure {
  margin: 10px 0 10px 0;
}

.flight #departure .icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 15px;
  color: #867b7b;
}

.flight #departure #action-icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 18px;
  color: #8da6b3;
  margin-right: 15px;
}

.action:hover {
  cursor: pointer;
  // font-size: 20px;
}

.segment {
  text-align: center;
  display: grid;
}

.b-left {
  border-left: 1px #e2e2e2 solid;
}

.subtitle {
  border-top: 1px #c5c5c5 solid;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px 1px 10px 1px;
}

.subtitle-display {
  display: none;
}

.subtitle div {
  text-align: left;
  color: #265215;
  font-size: 15px;
}
</style>